import Api from '@/api/index';

const Status = {
  namespaced: true,
  state: {
    allStatuses: [],
    statusByTitle:{}
  },
  getters: {
    filter_by_titles: (state) => (titles) => {
      titles = attributes.titles.map(t=>t.toLowerCase())
      return state.allStatuses.filter(s=> titles.includes( s.attributes.title.toLowerCase() )).attributes || []
    },
    find_by_title: (state) => (title) => {
      let status = state.allStatuses.find(s=> s.attributes.title.toLowerCase() == title.toLowerCase()).attributes || {}
      return status
    },
    find_by_id: (state) => (id) => {
      state.allStatuses.find(s=> Number(s.attributes.id) == Number(id)).attributes || {}
    },
  },

  mutations: {
    setAllStatuses(state, statuses) {
      state.allStatuses = [...statuses]
      

    }
  },

  actions: {
    index(context) {
      Api.Status.index().then(r => r.data).then(r => {
        context.commit('setAllStatuses', [...r.data])
      }).catch(err => {
        console.log(err)
      })
    }
  }

};

export default Status;
